import React, { useState } from 'react';
import { ChevronDown, ChevronUp, LucideIcon } from 'lucide-react';

export interface EventSignup {
  id: string;
  event_id: string;
  name: string;
  email: string | null;
  phone: string | null;
  created_at: string;
}

interface EventSignupListProps {
  title: string;
  icon: LucideIcon;
  iconClass: string;
  people: EventSignup[];
}

const EventSignupList: React.FC<EventSignupListProps> = ({ title, icon: Icon, iconClass, people }) => {
  const [expanded, setExpanded] = useState(false);

  if (people.length === 0) return null;

  return (
    <div className="mt-4 pt-4 border-t border-gray-200">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center space-x-2 mb-3 w-full text-left hover:bg-gray-50 -mx-2 px-2 py-1 rounded transition-colors"
        aria-expanded={expanded}
      >
        <Icon className={`w-5 h-5 flex-shrink-0 ${iconClass}`} />
        <strong className="text-gray-900 flex-1">{title} ({people.length})</strong>
        {expanded ? (
          <ChevronUp className="w-5 h-5 text-gray-600 flex-shrink-0" />
        ) : (
          <ChevronDown className="w-5 h-5 text-gray-600 flex-shrink-0" />
        )}
      </button>
      {expanded && (
        <div className="space-y-2">
          {people.map((person) => (
            <div key={person.id} className="bg-gray-50 rounded-lg p-3 text-sm">
              <div className="font-medium text-gray-900">{person.name}</div>
              {person.email || person.phone ? (
                <div className="text-gray-600 flex flex-wrap items-center gap-x-4 gap-y-1 mt-1">
                  {person.email && (
                    <a href={`mailto:${person.email}`} className="text-blue-600 hover:text-blue-800 break-all">
                      {person.email}
                    </a>
                  )}
                  {person.phone && (
                    <a href={`tel:${person.phone}`} className="text-blue-600 hover:text-blue-800">
                      {person.phone}
                    </a>
                  )}
                </div>
              ) : (
                <div className="text-xs text-gray-500 italic mt-1">Contact details removed after event</div>
              )}
              <div className="text-xs text-gray-400 mt-1">
                Registered: {new Date(person.created_at).toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EventSignupList;
